import React from 'react'
import CfLoader from '../CfLoader/CfLoader'

const SignUpInModalLoader = () => {
  return (
    <div className="absolute top-0 left-0 bg-black/30 w-full h-full flex justify-center items-center z-20 rounded-[1.25rem]">
    <CfLoader />
          </div>
  )
}

export default SignUpInModalLoader